<template>
	<section v-waypoint="{ active: true, callback: changeColorHeader, options: image_sectionIntersectionOptions }"
	         :style="{'background-color':bgColor}"
	         class="image_section"
	         v-bind:class="{image_section_boxed: isBoxed, image_section_affiche: isAffiche}">
		<div v-if="parallax || affiche" :id="image" ref="parallax"
		     v-lazy:background-image="require('../assets/images/'+image)"
		     class="image_section_parallax">
			<div v-if="legende && !affiche" ref="legende" class="image_section_legende" v-bind:class="{dark: isDarkLegende}"
			     v-html="legende"></div>
			<div v-else-if="affiche && legende" ref="legende" class="image_section_affiche_legende"
			     v-bind:class="{image_section_affiche_legende_light: isLight}" v-html="legende"></div>
			<div v-if="affiche" class="image_section_affiche_next" v-bind:class="{image_section_affiche_next_light: isLight}">
				<span class="scrolldown_icon">
					<font-awesome-icon :icon="['far', 'mouse-alt']"/>
				</span>
			</div>
		</div>
		<div v-else-if="!parallax && !affiche" :id="image" class="image_section_simple">
			<img
					ref="imageSimple"
					v-lazy="imgPath(image)"
					v-waypoint="{ active: true, callback: animViewportSingleImage}"
					v-bind:class="{border_desktop: hasMask}"
			>
			<div v-if="legende" ref="legende" class="image_section_legende" v-bind:class="{dark: isDarkLegende}"
			     v-html="legende"></div>
		</div>
	</section>

</template>

<script>

import Vue2Filters from "vue2-filters";
import {TweenMax} from "gsap";
import $ from "jquery";

export default {
	name: "ImageSingle",
	mixins: [Vue2Filters.mixin],
	components: {},
	data: function () {
		return {
			hasMask: (this.mask),
			isBoxed: (this.boxed),
			isAffiche: (this.affiche),
			isRatio: (this.ratioAffiche),
			isAnimated: (this.animated == "true"),
			isLight: (this.light == "true"),
			isDarkLegende: (this.darkLegende == "true"),
			image_sectionIntersectionOptions: {
				root: null,
				rootMargin: "-4% 0px -94% 0px",
				thresholds: 0
			}
		};
	},
	props: {
		image: {
			type: String,
			default: ""
		},
		mask: {
			type: String,
			default: ""
		},
		parallax: {
			type: String,
			default: ""
		},
		boxed: {
			type: String,
			default: ""
		},
		affiche: {
			type: String,
			default: ""
		},
		bgColor: {
			type: String,
			default: "transparent"
		},
		animated: {
			type: String,
			default: "true"
		},
		light: {
			type: String,
			default: "true"
		},
		legende: {
			type: String,
			default: ""
		},
		ratioAffiche: {
			type: String,
			default: ""
		},
		firstAffiche: {
			type: String,
			default: "false"
		},
		darkLegende: {
			type: String,
			default: ""
		}
	},
	methods: {
		imgPath: function (image) {
			return require("../assets/images/" + image);
		},
		animViewportSingleImage({going, direction}) {
			if (this.isAnimated == true) {
				let $elIMG = this.$refs.imageSimple;

				if (going === this.$waypointMap.GOING_IN && direction === this.$waypointMap.DIRECTION_TOP) {
					TweenMax.fromTo(
							$elIMG,
							1,
							{
								delay: 0.25,
								opacity: 0,
								translateY: 200
							},
							{
								opacity: 1,
								translateY: 0
							}
					);
				} else if (going === this.$waypointMap.GOING_IN && direction === this.$waypointMap.DIRECTION_BOTTOM) {
					TweenMax.fromTo(
							$elIMG,
							1,
							{
								delay: 0.25,
								opacity: 0,
								translateY: -200
							},
							{
								opacity: 1,
								translateY: 0
							}
					);
				} else if (going === this.$waypointMap.GOING_OUT && direction === this.$waypointMap.DIRECTION_TOP) {
					TweenMax.fromTo(
							$elIMG,
							1,
							{
								delay: 0.25,
								opacity: 0,
								translateY: -200
							},
							{
								opacity: 1,
								translateY: 0
							}
					);
				} else if (going === this.$waypointMap.GOING_OUT && direction === this.$waypointMap.DIRECTION_BOTTOM) {
					TweenMax.fromTo(
							$elIMG,
							1,
							{
								delay: 0.25,
								opacity: 0,
								translateY: 200
							},
							{
								opacity: 1,
								translateY: 0
							}
					);
				}
			}
		},
		changeColorHeader({going, direction}) {
			if (this.light != "true") {
				if (going === this.$waypointMap.GOING_IN) {
					$("#app").removeClass("lightHeader");
				}

				if (going === this.$waypointMap.GOING_OUT) {
					if (direction === this.$waypointMap.DIRECTION_BOTTOM || direction === this.$waypointMap.DIRECTION_TOP) {
						$("#app").addClass("lightHeader");
					}
				}
			}

			if (this.firstAffiche == "true") {
				if ((going === this.$waypointMap.GOING_IN && direction === this.$waypointMap.DIRECTION_TOP)) {
					$("#app").addClass("lightHeader");
					$("#app").removeClass("protectedHeader");
				} else if (going === this.$waypointMap.GOING_OUT && direction === this.$waypointMap.DIRECTION_BOTTOM) {
					$("#app").removeClass("lightHeader");
					$("#app").addClass("protectedHeader");
				}
			}

		},
		positionLegende() {
			if (this.isAffiche) {
				if (this.ratioAffiche) {
					let leftValue = "calc(" + this.ratioAffiche * 100 / 2 + "vh + 50% - 5rem)";
					this.$refs.legende.style.left = leftValue;
				}
			}
		}
	},
	updated() {
		this.positionLegende();
	},

	mounted() {
		this.positionLegende();
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@use '@/assets/scss/partials/variables' as *;
@use '@/assets/scss/partials/mixins' as *;
@use '@/assets/scss/partials/animations' as *;


.image_section {
	overflow: hidden;

	img {
		width: 100%;
	}

	&_simple {
		position: relative;

		.image_section_legende {
			background-color: transparent;
			bottom: 0;
			color: $white;
			padding: $padding-simple;
			position: absolute;
			right: 0;
			transition: $E-defaultTime $E-default;

			&.dark {
				color: $black;
			}
		}

		&:hover {
			.image_section_legende {
				background-color: rgba(0, 0, 0, 0.5);
				color: $white;
				transition: $E-defaultTime $E-default;
			}
		}
	}

	&_parallax {
		background-attachment: fixed;
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		height: $viewportheaderHeight;
		position: relative;
		@include breakpoint(lt-sm) {
			background-attachment: initial;
			height: 50vh;
		}

		.image_section_legende {
			background-color: transparent;
			bottom: 0;
			color: $white;
			padding: $padding-simple;
			position: absolute;
			right: 0;
			transition: $E-defaultTime $E-default;

			&.dark {
				color: $black;
			}
		}

		&:hover {
			.image_section_legende {
				background-color: rgba(0, 0, 0, 0.5);
				color: $white;
				transition: $E-defaultTime $E-default;
			}
		}
	}

	&_boxed {
		padding: 5rem;
		text-align: center;
		@include breakpoint(lt-sm) {
			padding: 3.5rem;
		}

		img {
			margin: auto;
			max-width: 110rem;
		}
	}

	&_affiche {
		box-sizing: border-box;
		height: 100vh;
		position: relative;
		@include breakpoint(lt-sm) {
			padding: 0 $padding-double;
		}

		.image_section_parallax {
			background-attachment: fixed;
			background-position: center;
			background-repeat: no-repeat;
			background-size: auto $boxedparallaxHeight;
			clip-path: inset(0 0 0 0);
			height: 100%;
			position: absolute;
			width: 100%;
			@include breakpoint(lt-sm) {
				background-attachment: initial;
				background-position: center center;
				background-size: auto 60vh;
				position: relative;
			}
		}

		&_next {
			animation: SlideInFromBottomMinor 1s ease-in-out infinite alternate;
			bottom: 3rem;
			color: #000000;
			cursor: default;
			left: 50%;
			position: fixed;
			@include transition();
			z-index: 1;

			@include breakpoint(lt-sm) {
				display: none;
			}

			.scrolldown_icon {
				font-size: 2rem;
				position: relative;
				transform: translateY(0);

				svg {
					color: $black;
				}
			}

			&_light {
				.scrolldown_icon {
					svg {
						color: $white;
					}
				}
			}
		}

		&_legende {
			color: $black;
			display: inline-block;
			left: calc(66.7vh / 2 + 50% - 5rem);
			max-width: 10rem;
			padding-left: 3rem;
			position: fixed;
			top: calc(100vh - 8rem);
			transform: translateY(-100%);
			white-space: normal;
			z-index: 1;

			@include breakpoint(lt-sm) {
				box-sizing: border-box;
				left: 50% !important;
				max-width: 80vw;
				padding: 1rem;
				position: absolute;
				top: calc(80vh + 1rem);
				transform: translateY(0) translateX(-50%);
				width: auto;
			}

			&_light {
				color: $white;
			}
		}
	}
}

</style>
